import axios from "axios";
import { useMutation } from "react-query";

const usePost = (url, options = {}) => {
    const token = document.cookie.split(`jwt=`).pop().split(';').shift();
    return useMutation(
        async (body) => {
            const { data } = await axios.post(url, body, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            return data;
        },
        {
            ...options,
        }
    );
};

export default usePost;
